import { DatePipe, DecimalPipe } from '@angular/common';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ReportFormatService {

  private datePipe = new DatePipe('en-US');
  private decimalPipe = new DecimalPipe('en-US');

  constructor() { }

  formatReport(report: any) {
    return {
        orderDate: report?.orderDate ? this.datePipe.transform(report?.orderDate, 'short') : '---',
        customerName: report?.vrn || '---',
        vrn: report.location || '---',
        vehicleModel: report?.vehicleModel || '---',
        vehicleUse: report?.vehicleUse || '---',
        carryingCapacity: report.carryingCapacity ? report.carryingCapacity : '---',
        vehicleValue: report?.vehicleValue || '---',
        insurer: report?.insurer || '---',
        insuranceType: report?.insuranceType || '---',
        coverStartDate: report?.coverStartDate || '---',
        nextRenewalDate: report?.nextRenewalDate || '---',
        amountDue: report?.amount || '---',
        paymentMethod: report?.paymentMethod || '---',
        status: report.status || '---',
    };
  }

}
